import React, { useRef, useState, useCallback } from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import FormsyForm from 'formsy-react'
import { fromJS } from 'immutable'
import PropTypes from 'prop-types'
import _get from 'lodash/get'
import {
  BASE_PLAYLISTS,
  PLAYLIST_TYPE_USER,
  getPlaylistDropdownOptions,
} from 'services/playlist'
import { Select } from 'components/FormInput.v2/FormInput'

function PlaylistDropdown ({
  currentFilter,
  handleSubmit,
  usersPlaylists,
}) {
  const [options] = useState(getPlaylistDropdownOptions(usersPlaylists))
  const currentOption = options.find((o) => o.value === currentFilter)
  const defaultOption = options.find((o) => o.value === 'default')
  const formEl = useRef(null)

  const handleIsValid = useCallback(() => {
    const { playlistType } = formEl.current.getModel()
    const shouldFetchPlaylist = BASE_PLAYLISTS.map((pl) => pl.type).includes(playlistType)
      || playlistType.startsWith(PLAYLIST_TYPE_USER)
    if (playlistType && shouldFetchPlaylist) {
      handleSubmit(playlistType)
    }
  }, [])

  return (
    <FormsyForm
      className="portal-playlist-v2-video_manager__playlist_select_form"
      onValid={handleIsValid}
      ref={formEl}
    >
      <Select
        className="portal-playlist-v2-video_manager__playlist_select"
        name="playlistType"
        label="Playlist"
        options={fromJS(options)}
        value={_get(currentOption, 'value') || defaultOption.value}
      >
        {options.map(({ label, value, id }) => {
          const isDefault = id === 'defaultOption'
          return (
            <option hidden={isDefault} disabled={isDefault} value={value} key={id}>
              {label}
            </option>
          )
        })}
      </Select>
    </FormsyForm>
  )
}

PlaylistDropdown.propTypes = {
  currentFilter: PropTypes.string,
  handleSubmit: PropTypes.func,
  usersPlaylists: ImmutablePropTypes.list,
}

export default PlaylistDropdown
